

export class ConsignorHelperProps {
}

export const InitialConsignorHelperProps: ConsignorHelperProps = <ConsignorHelperProps>{
};